import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const performanceRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtualagent-performance',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/performance',
};
